/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Directive, HostListener, inject } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../services/toast.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'input[type=file]',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: FileValueAccessor, multi: true },
  ],
})
export class FileValueAccessor implements ControlValueAccessor {
  value: any;
  onChange = (_: any) => {};
  onTouched = () => {};
  private readonly _translateService = inject(TranslateService);
  private _snackBar: ToastService = inject(ToastService);

  @HostListener('change', ['$event'])
  handleChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.item(0);

    // No file selected
    if (!file) {
      this.onChange(null);
      return;
    }

    // Reject 0-byte (empty) files and show snackbar
    if (file.size === 0) {
      this._snackBar.showError(
        this._translateService.instant('labels.warnings.0-filesize'),
      );
      this.onChange(null);
      input.value = ''; // reset input so user can choose another file
      return;
    }

    // Handle valid file
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.value = `fileName:${file.name},${reader.result as string}`;
      this.onChange(this.value);
    };
    reader.onerror = () => {
      this.onChange(null);
    };
  }

  @HostListener('blur')
  handleBlur(): void {
    this.onTouched();
  }

  writeValue(_value: any): void {}

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
